Pegasus.SpinnerView = Ember.View.extend({
  templateName: 'controls/spinner'
});